import { formatToTime } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Typography } from 'libs/ui';
import { VersionType } from 'modules/client/common/types';

import { CollapseText } from './CollapseText';
import { ContentWrapper, WrapperStyled } from './Version.styles';

interface Props<V extends VersionType> {
  version: V;
  isCurrentVersion: boolean;
  onClickVersion: (version: V) => void;
  isSelectedVersion: (version: V) => boolean;
}

export const Version = <V extends VersionType>({
  version,
  isCurrentVersion,
  isSelectedVersion,
  onClickVersion,
}: Props<V>) => {
  const { t } = useTranslation();
  const time = formatToTime(version.createdAt);
  const selected = isSelectedVersion(version);

  return (
    <WrapperStyled
      direction="row"
      justifyContent="space-between"
      selected={selected}
    >
      <ContentWrapper
        clickable={!selected}
        flex={1}
        spacing={4}
        onClick={() => onClickVersion(version)}
      >
        <Typography color="inherit" variant="bodyBold">
          {t(`client.client.versions.clientType.${version.updatedEntity.type}`)}
          {version.createdBy?.name && ` / ${version.createdBy?.name}`}
        </Typography>
        <Typography className="vestion-time" color="inherit" variant="caption">
          {time}
          {isCurrentVersion && (
            <> {t('client.client.versions.currentVersionLabel')}</>
          )}
        </Typography>
        <CollapseText text={version.reason} />
        {/* <Typography color="inherit">{version.reason}</Typography> */}
      </ContentWrapper>
    </WrapperStyled>
  );
};
